export const formatEUR = (n) =>
  new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);

export const formatNum = (n) =>
  new Intl.NumberFormat("es-ES").format(Number(n) || 0);

export const formatPercent = (n) => `${(Number(n) || 0).toFixed(1)}%`;

export const formatDate = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
};

export const formatDateTime = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleString("es-ES", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Madrid" });
  } catch {
    return s;
  }
};

export const RANK_LABELS = {
  Consultor: "Consultora",
  "Lider Junior": "Líder Júnior",
  "Lider Ejecutivo": "Líder Ejecutiva",
  "Lider Master": "Líder Master",
  Coordenador: "Coordinadora de Área",
  "Directora Nacional": "Directora Nacional",
};

export const RANK_COLORS = {
  Consultor: { bg: "bg-[#F2EFEA]", text: "text-[#736F68]", ring: "ring-[#E5E0D8]" },
  "Lider Junior": { bg: "bg-[#E3A569]/15", text: "text-[#9C6A2F]", ring: "ring-[#E3A569]/40" },
  "Lider Ejecutivo": { bg: "bg-[#C57B67]/15", text: "text-[#9A5340]", ring: "ring-[#C57B67]/40" },
  "Lider Master": { bg: "bg-[#8A9A86]/20", text: "text-[#4A5546]", ring: "ring-[#8A9A86]/50" },
  Coordenador: { bg: "bg-[#2D2A26]/10", text: "text-[#2D2A26]", ring: "ring-[#2D2A26]/30" },
  "Directora Nacional": { bg: "bg-[#C57B67]/20", text: "text-[#7A3520]", ring: "ring-[#C57B67]/50" },
};